const INSTAGRAM_FAQS = [
  {
    id: 1,
    categoria: 'Planos & Preços',
    icone: 'ri-price-tag-3-line',
    pergunta: 'Qual plano vale mais a pena para começar?',
    resumo: 'A Bia te ajuda a entender qual plano faz mais sentido para o seu momento de vida — gratuit, mensal ou anual.',
  },
  {
    id: 2,
    categoria: 'Cartas',
    icone: 'ri-mail-line',
    pergunta: 'Como funciona a carta para o eu futuro? Como eu vou receber?',
    resumo: 'Você escreve hoje e escolhe a data. No dia exato, a carta chega no seu e-mail — como uma mensagem do seu passado.',
  },
  {
    id: 3,
    categoria: 'Exercícios PNL',
    icone: 'ri-brain-line',
    pergunta: 'O que é PNL e como os exercícios funcionam na prática?',
    resumo: 'PNL (Programação Neurolinguística) são técnicas para reprogramar crenças e padrões mentais através de exercícios guiados.',
  },
  {
    id: 4,
    categoria: 'Garantia',
    icone: 'ri-shield-check-line',
    pergunta: 'Tem garantia? E se eu não gostar posso cancelar?',
    resumo: 'Sim! 7 dias de garantia incondicional. Se não ficar satisfeita, devolvemos 100% do valor sem perguntas.',
  },
  {
    id: 5,
    categoria: 'Privacidade',
    icone: 'ri-lock-line',
    pergunta: 'Minhas cartas e diário são privados? Alguém tem acesso?',
    resumo: 'Tudo é completamente privado e criptografado. Só você acessa o conteúdo das suas cartas e diário.',
  },
  {
    id: 6,
    categoria: 'Resultados',
    icone: 'ri-sparkling-line',
    pergunta: 'Em quanto tempo vou sentir resultado com o método?',
    resumo: 'Os resultados variam, mas muitas alunas relatam mudanças de perspectiva já nas primeiras semanas de prática consistente.',
  },
  {
    id: 7,
    categoria: 'Acesso',
    icone: 'ri-device-line',
    pergunta: 'Funciona no celular? Precisa baixar algum app?',
    resumo: 'Funciona direto pelo navegador no celular, tablet ou computador. Sem precisar baixar nada.',
  },
  {
    id: 8,
    categoria: 'Comunidade',
    icone: 'ri-group-line',
    pergunta: 'Tem grupo ou comunidade para as alunas se conectarem?',
    resumo: 'Sim! Há uma comunidade exclusiva onde as alunas compartilham vitórias, se apoiam e crescem juntas.',
  },
];

const FAQBia = () => {
  const handleAskBia = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    btn?.click();
  };

  return (
    <section className="py-20 bg-luxury-black relative overflow-hidden">
      {/* Background */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/3 rounded-full blur-[200px]" />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-10 h-px bg-gold-500/40" />
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              Assistente Virtual
            </span>
            <div className="w-10 h-px bg-gold-500/40" />
          </div>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white mb-4">
            Dúvidas do{' '}
            <span className="text-gold-400 italic">Instagram?</span>
            <br />
            <span className="text-white/80 text-2xl md:text-3xl">A Bia responde agora</span>
          </h2>
          <p className="font-['Montserrat'] text-white/50 text-sm max-w-xl mx-auto leading-relaxed">
            Estas são as perguntas que mais chegam nas nossas redes. Clique em qualquer dúvida e a Bia responde em tempo real — via chat ou voz.
          </p>

          {/* Bia avatar button */}
          <button
            onClick={handleAskBia}
            className="mt-8 inline-flex items-center gap-3 bg-gradient-to-r from-gold-500/15 to-gold-600/10 border border-gold-500/30 rounded-full px-6 py-3 hover:border-gold-500/60 hover:bg-gold-500/20 transition-all duration-300 cursor-pointer group"
          >
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <img
                src="https://public.readdy.ai/ai/img_res/d4a067e5333bbf90d77c73cf667731f5.jpg"
                alt="Bia Holmes"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-['Montserrat'] text-gold-400 text-sm whitespace-nowrap group-hover:text-gold-300 transition-colors">
              Abrir chat com a Bia
            </span>
            <i className="ri-arrow-right-line text-gold-400 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {INSTAGRAM_FAQS.map((faq) => (
            <div
              key={faq.id}
              className="group relative bg-white/[0.03] border border-white/[0.08] rounded-xl p-5 hover:border-gold-500/30 hover:bg-white/[0.06] transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-lg bg-gold-500/10 border border-gold-500/20 group-hover:bg-gold-500/20 transition-colors">
                  <i className={`${faq.icone} text-gold-400 text-base`} />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <span className="font-['Montserrat'] text-[10px] tracking-widest uppercase text-gold-500/70 mb-1 block">
                    {faq.categoria}
                  </span>
                  <h4 className="font-['Playfair_Display'] text-white text-sm leading-snug mb-2">
                    {faq.pergunta}
                  </h4>
                  <p className="font-['Montserrat'] text-white/40 text-xs leading-relaxed mb-3">
                    {faq.resumo}
                  </p>

                  <button
                    onClick={handleAskBia}
                    className="inline-flex items-center gap-1.5 text-gold-400 hover:text-gold-300 font-['Montserrat'] text-xs transition-colors cursor-pointer group/btn"
                  >
                    <i className="ri-customer-service-2-line text-sm" />
                    <span>Perguntar à Bia</span>
                    <i className="ri-arrow-right-s-line group-hover/btn:translate-x-0.5 transition-transform" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-white/[0.03] border border-gold-500/20 rounded-2xl px-8 py-6">
            <div className="text-left">
              <p className="font-['Playfair_Display'] text-white text-base mb-1">
                Tem outra dúvida?
              </p>
              <p className="font-['Montserrat'] text-white/40 text-xs">
                A Bia está online agora e responde qualquer pergunta em segundos.
              </p>
            </div>
            <button
              onClick={handleAskBia}
              className="whitespace-nowrap flex items-center gap-2 bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] text-sm font-semibold px-6 py-3 rounded-lg hover:shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all cursor-pointer"
            >
              <i className="ri-chat-smile-3-line" />
              Falar com a Bia agora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQBia;
